import classnames from 'classnames/bind'
import React from 'react'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'

import InlineCta from '~/components/UI/InlineCta'

import { LABEL } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

type LetterProps = {
  letter?: string
  isClickable?: boolean
}
export type IndexListAlphabetFiltersProps = {
  className?: string
  letters?: LetterProps[]
  currentLetter?: string
  onClickLetter?: (letter) => void
}

function IndexListAlphabetFilters({
  className,
  letters,
  currentLetter,
  onClickLetter,
}: IndexListAlphabetFiltersProps) {
  const t = useTranslate()

  return (
    <div className={cx(css.IndexListAlphabetFilters, className)}>
      <InlineCta
        textPreset={GlobalTextPreset.Cta12Grotesk}
        theme={
          !currentLetter ? GlobalThemeColors.Black : GlobalThemeColors.Gray
        }
        className={cx(css.letter, css.letterAll)}
        onClick={(e) => {
          e.preventDefault()
          onClickLetter && onClickLetter(null)
        }}
        lineProps={{
          initialLineState: !currentLetter ? 'underlined' : 'none',
        }}>
        {t(LABEL.ALL)}
      </InlineCta>

      {letters?.map((letterItem, index) => {
        const isActive = letterItem.letter === currentLetter

        return (
          <InlineCta
            textPreset={GlobalTextPreset.Cta12Grotesk}
            theme={isActive ? GlobalThemeColors.Black : GlobalThemeColors.Gray}
            className={cx(css.letter, {
              isNotClickable: !letterItem?.isClickable,
            })}
            onClick={(e) => {
              if (letterItem.isClickable) {
                e.preventDefault()
                onClickLetter && onClickLetter(letterItem.letter)
              }
            }}
            lineProps={{ initialLineState: isActive ? 'underlined' : 'none' }}
            key={`letter_${index}`}>
            {letterItem.letter}
          </InlineCta>
        )
      })}
    </div>
  )
}

IndexListAlphabetFilters.defaultProps = {}

export default IndexListAlphabetFilters
